import { ActivatedRoute } from '@angular/router';
import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { FormBuilder, Validators } from '@angular/forms';
import { FormTools } from "src/shared/util/FormTools";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { AppEventNames } from "src/app-client/_appCommon/base/Constants";
import { BroadcastManager } from "src/app-client/_appCommon/base/BroadcastManager";
import { ClassType, ClassTypeLabel, HorizontalOverbiteType, HorizontalOverbiteTypeLabel, PositionType, PositionTypeExtractions, PositionTypeExtractionsLabel, PositionTypeLabel, TorqueLowerType, TorqueLowerTypeLabel, TorqueUpperType, TorqueUpperTypeLabel } from "src/app-client/_appCommon/base/AppInterfaceAndBaseClasses";
import { PrescriptionDataService } from "src/app-client/_dataservices/PrescriptionDataService";
import { SetupDataService } from 'src/app-client/_dataservices/SetupDataService';

@Component({
  selector: 'app-client-fifth-step',
  templateUrl: './fifth-step.component.html',
  styleUrls: ['../crud-prescription.component.css'],
  providers: [PrescriptionDataService]
})
export class FifthStepComponent extends FormTools implements OnChanges
{
  public prescriptionNumber = 5;
  public isCaseDetail: boolean;

  private unsubscribe: Subject<void> = new Subject();
  public formStep5Valid: boolean = false;
  public positionTypeOptions = [
    { value: PositionType.Keep, display: PositionTypeLabel.get(PositionType.Keep) },
    { value: PositionType.Protrude, display: PositionTypeLabel.get(PositionType.Protrude) },
    { value: PositionType.Retract, display: PositionTypeLabel.get(PositionType.Retract) },
  ];

  public positionTypeExtractionsOptions = [
    { value: PositionTypeExtractions.Keep, display: PositionTypeExtractionsLabel.get(PositionTypeExtractions.Keep) },
    { value: PositionTypeExtractions.MoveToMesial, display: PositionTypeExtractionsLabel.get(PositionTypeExtractions.MoveToMesial) },
    { value: PositionTypeExtractions.Retract, display: PositionTypeExtractionsLabel.get(PositionTypeExtractions.Retract) },
  ];


  public torqueLowerTypeOptions = [
    { value: TorqueLowerType.Keep, display: TorqueLowerTypeLabel.get(TorqueLowerType.Keep) },
    { value: TorqueLowerType.ProIncline, display: TorqueLowerTypeLabel.get(TorqueLowerType.ProIncline) },
    { value: TorqueLowerType.RetroIncline, display: TorqueLowerTypeLabel.get(TorqueLowerType.RetroIncline) },
  ];

  public torqueUpperTypeOptions = [
    { value: TorqueUpperType.Keep, display: TorqueUpperTypeLabel.get(TorqueUpperType.Keep) },
    { value: TorqueUpperType.Move, display: TorqueUpperTypeLabel.get(TorqueUpperType.Move) },
    { value: TorqueUpperType.Overcorrect, display: TorqueUpperTypeLabel.get(TorqueUpperType.Overcorrect) },
  ];

  public horizontalOverbiteTypeOptions = [
    { value: HorizontalOverbiteType.Contacts, display: HorizontalOverbiteTypeLabel.get(HorizontalOverbiteType.Contacts) },
    { value: HorizontalOverbiteType.NoContacts, display: HorizontalOverbiteTypeLabel.get(HorizontalOverbiteType.NoContacts) },
    { value: HorizontalOverbiteType.SpaceBetween, display: HorizontalOverbiteTypeLabel.get(HorizontalOverbiteType.SpaceBetween) },
  ];

  public classTypeOptions = [
    { value: ClassType.ClassOne, display: ClassTypeLabel.get(ClassType.ClassOne) },
    { value: ClassType.ClassTwo, display: ClassTypeLabel.get(ClassType.ClassTwo) },
    { value: ClassType.ClassThree, display: ClassTypeLabel.get(ClassType.ClassThree) },
  ];

  @Input('prescriptionData') public prescriptionData!: any;

  constructor(formBuilder: FormBuilder, private activatedRoute: ActivatedRoute, private prescriptionDataService: PrescriptionDataService,private setupDataService:SetupDataService)
  {
    super(10, formBuilder);
  }

  ngOnChanges(changes: SimpleChanges): void
  {
    if (changes['prescriptionData'])
    {
      this.stepFormGroup?.controls['upperIncisorsPosition'].setValue(changes['prescriptionData'].currentValue.upperIncisorsPosition);
      this.stepFormGroup?.controls['upperIncisorsTorque'].setValue(changes['prescriptionData'].currentValue.upperIncisorsTorque);
      this.stepFormGroup?.controls['lowerIncisorsPosition'].setValue(changes['prescriptionData'].currentValue.lowerIncisorsPosition);
      this.stepFormGroup?.controls['lowerIncisorsTorque'].setValue(changes['prescriptionData'].currentValue.lowerIncisorsTorque);
      this.stepFormGroup?.controls['upperRearAnchorage'].setValue(changes['prescriptionData'].currentValue.upperRearAnchorage);
      this.stepFormGroup?.controls['lowerRearAnchorage'].setValue(changes['prescriptionData'].currentValue.lowerRearAnchorage);
      this.stepFormGroup?.controls['horizontalOverbiteType'].setValue(changes['prescriptionData'].currentValue.horizontalOverbiteType);
      this.stepFormGroup?.controls['horizontalOverbiteSpace'].setValue(changes['prescriptionData'].currentValue.horizontalOverbiteSpace);
      this.stepFormGroup?.controls['objectivesInAnteroposteriorComments'].setValue(changes['prescriptionData'].currentValue.objectivesInAnteroposteriorComments);
      this.stepFormGroup?.controls['canineRelationshipMaintainOriginalRightRelationship'].setValue(changes['prescriptionData'].currentValue.canineRelationshipMaintainOriginalRightRelationship);
      this.stepFormGroup?.controls['canineRelationshipRightRelationshipType'].setValue(changes['prescriptionData'].currentValue.canineRelationshipRightRelationshipType);
      this.stepFormGroup?.controls['canineRelationshipMaintainOriginalLeftRelationship'].setValue(changes['prescriptionData'].currentValue.canineRelationshipMaintainOriginalLeftRelationship);
      this.stepFormGroup?.controls['canineRelationshipLeftRelationshipType'].setValue(changes['prescriptionData'].currentValue.canineRelationshipLeftRelationshipType);
      this.stepFormGroup?.controls['molarRelationshipMaintainOriginalRightRelationship'].setValue(changes['prescriptionData'].currentValue.molarRelationshipMaintainOriginalRightRelationship);
      this.stepFormGroup?.controls['molarRelationshipRightRelationshipType'].setValue(changes['prescriptionData'].currentValue.molarRelationshipRightRelationshipType);
      this.stepFormGroup?.controls['molarRelationshipMaintainOriginalLeftRelationship'].setValue(changes['prescriptionData'].currentValue.molarRelationshipMaintainOriginalLeftRelationship);
      this.stepFormGroup?.controls['molarRelationshipLeftRelationshipType'].setValue(changes['prescriptionData'].currentValue.molarRelationshipLeftRelationshipType);
      this.stepFormGroup?.controls['relationshipsValuesComments'].setValue(changes['prescriptionData'].currentValue.relationshipsValuesComments);
      
    }
  }

  ngOnInit(): void
  {
    this.activatedRoute.url.subscribe(url =>
    {
      this.isCaseDetail = url.toString().contains('detail');
    });

    BroadcastManager.Instance.on(AppEventNames.onUpdatePrescriptionStepByNumber)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(([e]) =>
      {
        if (e[0] == "5")
        {
          if (this.stepFormGroup.valid) 
          {
            let number = e[0];

            if (number && this.prescriptionNumber == number)
              this.updateStepPrescription();
          }
          else 
          {
            this.setDangerAlert("Información requerida para avanzar")
          }
        }
      });

    this.stepFormGroup = this.formBuilder.group({
      id: [0, null],
      upperIncisorsPosition: [PositionType.Keep, null],
      upperIncisorsTorque: [TorqueUpperType.Keep, null],
      lowerIncisorsPosition: [PositionType.Keep, null],
      lowerIncisorsTorque: [TorqueLowerType.Keep, null],
      upperRearAnchorage: [PositionType.Keep, null],
      lowerRearAnchorage: [PositionType.Keep, null],
      horizontalOverbiteType: [HorizontalOverbiteType.Contacts, null],
      horizontalOverbiteSpace: [0, [Validators.maxLength(10),Validators.minLength(.1)]],
      objectivesInAnteroposteriorComments: ['', null],
      canineRelationshipMaintainOriginalRightRelationship: [false, null],
      canineRelationshipRightRelationshipType: [null, null],
      canineRelationshipMaintainOriginalLeftRelationship: [false, null],
      canineRelationshipLeftRelationshipType: [null, null],
      molarRelationshipMaintainOriginalRightRelationship: [false, null],
      molarRelationshipRightRelationshipType: [null, null],
      molarRelationshipMaintainOriginalLeftRelationship: [false, null],
      molarRelationshipLeftRelationshipType: [null, null],
      relationshipsValuesComments: ['', null],
    });

    BroadcastManager.Instance.on("step5Valid")
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(([data]: any) =>
    {
      this.formStep5Valid = data[0];
    });

    this.stepFormGroup.valueChanges.subscribe((value) => {
      this.inputValidationsStep5();
    });
    
  }

  ngAfterViewInit()
  {
    this.inputValidationsStep5();
  }

  ngOnDestroy(): void
  {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public updateStepPrescription(): void
  {
    // Set prescriptionId in stepFormGroup
    if (this.stepFormGroup.valid)
    {
      this.stepFormGroup.controls['id'].setValue(this.GetPrescriptionId);

      this.prescriptionDataService.updatePrescriptionStep(this.GetSetupId, this.prescriptionNumber, this.stepFormGroup.value)
        .subscribe((response) =>
        {
          let body = 
          {
            id: this.GetSetupId,
            currentStep: 9
          }
          this.updateSetupCurrentStep(body);
          this.setSuccessAlert('Paso guardado correctamente');
        }, fail =>
        {
          this.setWarningAlert('Hubo un error al actualizar la prescripción: ' + fail.error.message);
        });
    }
    else
    {
      this.setWarningAlert("Hay campos obligatorios sin completar.");
    }
  }

  public inputValidationsStep5()
  {
    if (this.stepFormGroup) 
    {
      if (this.stepFormGroup.controls["relationshipsValuesComments"].value != "" && this.stepFormGroup.controls["relationshipsValuesComments"].value != null
        &&((this.stepFormGroup?.controls['horizontalOverbiteSpace'].valid && this.stepFormGroup?.controls['horizontalOverbiteSpace'].value!=null)
        ||this.stepFormGroup?.controls['horizontalOverbiteType'].value != HorizontalOverbiteType.SpaceBetween)
      ) {
        BroadcastManager.Instance.broadcast("step5Valid", true);
      }
      else {
        BroadcastManager.Instance.broadcast("step5Valid", false);
      }
    }
   
    
  }

  public disabledButtonStages():boolean
  {
    if(!this.formStep5Valid)
    {
      return true;
    }
    return false;
  }

  private updateSetupCurrentStep(body: any)
  {

    this.setupDataService.updateSetupCurrentStep(body)
    .subscribe(()=>
    {
      this.setCurrentSetupStep(body.currentStep);
    });
  }
}